import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SetOutline, SmileOutline } from 'antd-mobile-icons';

const blocks = [
  {
    id: 'zavhoz',
    title: 'Завхоз',
    description: 'Заявки по хозяйству: сантехника, электрика, мебель',
    icon: SetOutline,
    color: '#fa8c16',
    bg: '#fff7e6',
    path: '/zavhoz',
  },
  {
    id: 'satisfaction',
    title: 'Удовлетворенность',
    description: 'Поговорите с виртуальным HR — как вам работается?',
    icon: SmileOutline,
    color: '#52c41a',
    bg: '#f6ffed',
    path: '/satisfaction',
  },
];

function OfficePage() {
  const navigate = useNavigate();

  return (
    <div>
      <h2 style={{ margin: '12px 0', fontSize: 20, fontWeight: 600 }}>Офис</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {blocks.map((block) => {
          const Icon = block.icon;
          return (
            <div
              key={block.id}
              onClick={() => !block.disabled && navigate(block.path)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 16,
                padding: 16,
                borderRadius: 16,
                background: '#fff',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0',
                opacity: block.disabled ? 0.6 : 1,
                cursor: block.disabled ? 'not-allowed' : 'pointer',
                transition: 'transform 0.15s, box-shadow 0.15s',
              }}
              onMouseDown={(e) => {
                if (!block.disabled) {
                  e.currentTarget.style.transform = 'scale(0.98)';
                }
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <div
                style={{
                  width: 56,
                  height: 56,
                  borderRadius: 16,
                  background: block.bg,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: block.color,
                  fontSize: 28,
                  flexShrink: 0,
                }}
              >
                <Icon />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    fontSize: 17,
                    fontWeight: 600,
                    color: '#262626',
                    marginBottom: 4,
                  }}
                >
                  {block.title}
                </div>
                <div style={{ fontSize: 13, color: '#8c8c8c', lineHeight: 1.4 }}>
                  {block.description}
                </div>
              </div>
              {!block.disabled && (
                <span style={{ color: '#bfbfbf', fontSize: 18 }}>›</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default OfficePage;
